var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_4904)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5714 2.12143H16.9457C17.5243 2.12143 18 2.59714 18 3.17571C18 3.75429 17.5243 4.23 16.9457 4.23H16.7143V14.2843C16.7143 16.3286 15.0557 17.9871 13.0114 17.9871H4.98857C2.94429 17.9871 1.28571 16.3286 1.28571 14.2843V4.23H1.05429C0.475714 4.23 0 3.75429 0 3.17571C0 2.59714 0.475714 2.12143 1.05429 2.12143H6.42857V1.28571C6.42857 0.578571 7.00714 0 7.71429 0H10.2857C10.9929 0 11.5714 0.578571 11.5714 1.28571V2.12143ZM13.0114 15.8914C13.8986 15.8914 14.6057 15.1714 14.6057 14.2971L14.5929 14.2843V4.23H3.39429V14.2971C3.39429 15.1843 4.11429 15.8914 4.98857 15.8914H13.0114ZM7.05847 14.2334C7.63704 14.2334 8.11276 13.7576 8.11276 13.1791V7.03336C8.11276 6.45479 7.63704 5.97907 7.05847 5.97907C6.4799 5.97907 6.00419 6.45479 6.00419 7.03336V13.1662C6.00419 13.7448 6.4799 14.2205 7.05847 14.2205V14.2334ZM10.9414 14.2334C11.5199 14.2334 11.9956 13.7576 11.9956 13.1791V7.03336C11.9956 6.45479 11.5199 5.97907 10.9414 5.97907C10.3628 5.97907 9.88707 6.45479 9.88707 7.03336V13.1662C9.88707 13.7448 10.3628 14.2205 10.9414 14.2205V14.2334Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_4904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.ce154e946ddf5496cb04e85a4c5bbc2c.svg";
export { ForwardRef as ReactComponent };